module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg6-5001fa9c91e9504793448d94ccffb35e.png";